// Listing available in the navbar
// Object keys and title field in french cause in the layout
var options = {
  Bienvenue:{title:'Bienvenue'},
  Carte:{title:'Carte'},
  Postes:{title:'Postes'},
  Score:{title:'Score'},
};

export default options;



// WEBPACK FOOTER //
// ./src/data/options.js